declare const window: any;

// Are we in CMS? in which preview?
declare const isPreviewPage: boolean;
declare const isLivePreviewPage: boolean;

import 'json3';
import 'promise-polyfill/src/polyfill';
import {
    trackAnalyticsEvent,
    trackAnalyticsView,
    FireAnalyticsTagEventOnDownload,
    FireAnalyticsTagEventOnSearch,
    FireAnalyticsTagEventOnSearchResultItemClick,
    FireAnalyticsTagEventQuiz,
    FireTealiumEvent,
    FireTealiumEventOnDownload, getAnalyticsPageData
} from '../helpers/analytics';
import moduleManager from '../helpers/moduleManager';
import imenh from '../helpers/image_enhancer';
import optimEvs from '../helpers/optim_events';

// to support old module structure
import '../loader/loader-module';
import '../loader/loader-utils';

window.RFE = window.RFE || {};

// init optimized events
optimEvs.initGlobal();

// patternlab specific files
if (process.env.NODE_ENV === 'patternlab') {
    require('../patternlab/conf');
}

// standard modules supporting DOMContentLoaded
moduleManager.addDependencies([
    { // Polyfill JavaScript Array.prototype.find for older browsers (e.g. IE 10, IE 11)
        dep: ['array_find'],
        test: () => !Array.prototype.find
    },
    {
        dep: ['nav20_analytics'],
        test: (context) => !!context.querySelector('[data-analytics-tales="true"]')
        && !(/[\&\?](previewId|design)=/).test(window.location.href)
    },
    {
        dep: ['prog_install_prompt']
    },
    {
        dep: ['header'],
        test: (context) => !!context.querySelector('.hdr .actions')
    },
    {
        dep: ['facebook_api'],
        test: (context) => !!context.querySelector('.fbVideoSnippet,.fbVideoSnippetProcessed')
    },
    {
        dep: ['youtube_iframe'],
        test: (context) => !!context.querySelector('[data-sp_api=\'youtube\']')
    },
    {
        dep: ['collapsible'],
        test: (context) => !!context.querySelector('.collapsible')
    },
    {
        dep: ['switcher'],
        test: (context) => !!context.querySelector('[data-switcher-trigger="true"]')
    },
    {
        dep: ['scroll_to_link'],
        test: (context) => !!context.querySelector('[data-target-id]')
    },
    {
        dep: ['highlights', 'hljson_loader'],
        test: (context) => {
            // MilanC: lets try if this should stop from display breaking news in cms iframes
            const isPreview = (/[\&\?](previewId|design)=/).test(window.location.href);
            // const isEmbedded = window.self !== window.top;
            // ^^ bugfix for VOA RESP-4681

            return !!context.querySelector('.c-hlights') && !isPreview && // !isEmbedded &&
                !context.querySelector('#sg-patterns'); // PL Only: exclude from PL libraries
        }
    },
    {
        dep: ['smooth_scroll'],
        test: (context) => !!context.querySelector('a[href^="#"]')
    },
    {
        dep: ['google_translate'],
        test: () => window.self === window.top // not for CMS Inline Edit
    },
    {
        dep: ['content_sharing'], // new content sharing
        test: (context) => !!context.querySelector('.js-content-sharing')
    },
    {
        dep: ['content_sharing_player'], // old content sharing is now used only for MMP
        test: (context) => !!context.querySelector('.js-share--expandable')
    },
    {
        dep: ['load_more'],
        test: (context) => !!context.querySelector('.link-showMore')
        || !!context.querySelector('.tab-loadContent')
        || !!context.querySelector('.link-ajax')
        || !!context.querySelector('.lazy-scroll-load')
    },
    {
        dep: ['content_tabs'],
        test: (context) => !!context.querySelector('.js-nav-tabs--content')
    },
    {
        dep: ['swipe_slide'],
        test: (context) => !!context.querySelector('.swipe-slide')
    },
    {
        dep: ['slider_nav_tabs'],
        test: (context) => !!context.querySelector('.nav-tabs')
    },
    {
        dep: ['carousel'],
        test: (context) => !!context.querySelector('.carousel')
    },
    {
        dep: ['slider_gallery'],
        test: (context) => !!context.querySelector('.js-img-compare')
    },
    {
        dep: ['simple_captcha']
    },
    {
        dep: ['validation', 'comments'],
        test: (context) => !!context.querySelector('.comments--pangea')
        && !context.querySelector('.news__comments')
    },
    {
        dep: ['category_menu'],
        test: (context) => !!context.querySelector('.category-menu')
    },
    {
        dep: ['analyticstag_event']
    },
    {
        dep: ['flexible_iframe'],
        test: (context) => !!context.querySelector('.flexible-iframe')
    },
    {
        dep: ['show_single_line'],
        test: (context) => !!context.querySelector('.show-single-line')
    },
    {
        dep: ['content_floated'],
        test: (context) => !!context.querySelector('.content-floated')
    },
    {
        dep: ['slider_fred'],
        test: (context) => !!context.querySelector('.fredContent__controls')
    },
    {
        dep: ['validation', 'poll'],
        test: (context) => !!context.querySelector('.poll')
    },
    {
        dep: ['validation', 'subscribe'],
        test: (context) => !!context.querySelector('.subscribe')
    },
    {
        dep: ['validation', 'quiz'],
        test: (context) => !!context.querySelector('.quiz')
    },
    {
        dep: ['validation', 'login'],
        test: (context) => !!context.querySelector('.js-login-box')
    },
    {
        // this is now for liberty net only
        dep: ['randomize_bg'],
        test: (context) => !!context.querySelector('.pg-login-special')
    },
    {
        dep: ['validation', 'register'],
        test: (context) => !!context.querySelector('.js-register-form')
    },
    {
        dep: ['validation', 'password_recover'],
        test: (context) => !!context.querySelector('.js-password-recover-form')
    },
    {
        dep: ['validation', 'password_reset'],
        test: (context) => !!context.querySelector('.js-password-reset-form')
    },
    {
        dep: ['popup_opener'],
        test: (context) => !!context.querySelector('.btn-popout-player')
    },
    {
        dep: ['whatsapp_share_button']
    },
    {
        dep: [
            'multimedia_player_utils', 'multimedia_player_mpd',
            'multimedia_player_analytics', 'multimedia_player_core', 'multimedia_player_ui'
        ],
        test: (context) => {
            return !!context.querySelector('.c-mmp') ||
                !!context.querySelector('.quiz') ||
                !!context.querySelector('.pg-liveblog')
        }
    },
    {
        dep: ['sticky_player_pangea_video'],
        test: (context) => !!context.querySelector('[data-sp_api=\'pangea-video\']')
        && !isPreviewPage
    },
    {
        dep: ['sticky_player_youtube'],
        test: (context) => !!context.querySelector('[data-sp_api=\'youtube\']')
        && !isPreviewPage
    },
    {
        dep: ['playlist'],
        test: (context) => !!context.querySelector('.playlist')
    },
    {
        dep: ['sticky_player_history_handler'],
        test: () => !!window.history
        && !isPreviewPage
    },
    {
        dep: ['sticky_player'],
        test: (context) => !!context.querySelector('[data-sp_api]')
        && !isPreviewPage
    },
    {
        dep: ['validation', 'ugc'],
        test: (context) => !!context.querySelector('.js-ugc-box')
    },
    {
        dep: ['copy_to_clipboard']
    },
    {
        dep: ['slide_in_widget'],
        test: (context) => !!context.querySelector('.slide-in-wg')
    },
    {
        dep: ['calendar'],
        test: (context) => !!context.querySelector('.calendar')
    },
    {
        dep: ['editorial_bar'],
        test: () => {
            const bar_data = window.bar_data;
            const isLoggedIn = (typeof bar_data !== 'undefined') &&
                (typeof bar_data.cookieName !== 'undefined') &&
                (RFE.readCookie(bar_data.cookieName))
                ;
            const isPreview = (/[\&\?](previewId|design)=/).test(window.location.href);
            const isEmbedded = (
                (typeof bar_data !== 'undefined') &&
                bar_data.isEmbedded &&
                bar_data.isEmbedded !== '0'
            ) ||
                window.self !== window.top
                ;

            return !!isLoggedIn && !isPreview && !isEmbedded;
        }
    },
    {
        dep: ['widget_switcher'],
        test: (context) => !!context.querySelector('.js-widget-switcher')
    },
    {
        dep: ['captcha_form_helper'],
        test: (context) => !!context.querySelector('.captcha-show')
    },
    {
        dep: ['graphic_content'],
        test: (context) => !!context.querySelector('.content-advisory')
    },
    {
        dep: ['image_expander'],
        test: (context) => !!context.querySelector('.c-lightbox')
    },
    {
        dep: ['sticky_btn_panel'],
        test: (context) => (!!context.querySelector('.sticky-btn')
        || (!!context.querySelector('.sticky-panel') && (typeof CSS === 'undefined' || !CSS.supports('position', 'sticky'))))
        && !isPreviewPage
    },
    {
        dep: ['accordeon'],
        test: (context) => !!context.querySelector('.accordeon')
    },
    {
        dep: ['share_link'],
        test: (context) => !!context.querySelector('.ctc')
    },
    {
        dep: ['combobox_helper'],
        test: (context) => !!context.querySelector('.dropdown')
    },
    {
        dep: ['date_picker'],
        test: (context) => !!context.querySelector('.form__date-picker')
    },
    {
        dep: ['tags'],
        test: (context) => !!context.querySelector('.tags')
    },
    {
        dep: ['livepage'],
        test: (context) => !!context.querySelector('.livepage')
    },
    {
        dep: ['search_page'],
        test: (context) => !!context.querySelector('.pg-srch')
    },
    {
        dep: ['video_enhancer'],
        test: (context) => !!context.querySelector('.video')
    },
    {
        dep: ['sharing_open'],
        test: (context) => !!context.querySelector('.share__item')
    },
    {
        dep: ['comments_load_more'],
        test: (context) => !!context.querySelector('.btn--load-more-comments')
    },
    {
        dep: ['comment_pangea'],
        test: (context) => !!context.querySelector('.comment--pangea')
    },
    {
        dep: ['comments_fb'],
        test: (context) => !!context.querySelector('.comments--fb')
    },
    {
        dep: ['async_loaded_player'],
        test: (context) => !!context.querySelector('.aslp')
    },
    {
        dep: ['podcast_wg'],
        test: (context) => !!context.querySelector('.podcast-wg')
    },
    {
        dep: ['podcast_sub'],
        test: (context) => !!context.querySelector('.podcast-sub')
    },
    {
        dep: ['non_form_sys_msg'],
        test: (context) => !!context.querySelector('.calendar-component .sys-msg')
    },
    {
        dep: ['transition_toggler'],
        test: (context) => !!context.querySelector('.trans-target')
    },
    {
        dep: ['nav20'],
        test: (context) => !!context.querySelector('.hdr-20')
    },
    {
        dep: ['chapter_nav'],
        test: (context) => !!context.querySelector('.sticky-share-container .pg-title') && !!context.querySelector('[data-create-chapter=true]')
    },
    {
        dep: ['live_b_drop'],
        test: (context) => !!context.querySelector('.live-b-drop')
        && window.location.href.indexOf('patternlab') === -1
        && !(/[\&\?](previewId|design)=/).test(window.location.href)
    },
    {
        dep: ['sticky_sharing20'],
        test: (context) => !!context.querySelector('.content-sharing--sticky .content-sharing__list')
        && !!context.querySelector('.hdr-20')
    },
    {
        dep: ['news_layout'],
        test: (context) => !!context.querySelector('#newsItems')
    },
    {
        dep: ['live_blog_page_notification'],
        test: (context) => !!context.querySelector('.update-liveblog')
        && !isPreviewPage
    },
    {
        dep: ['feature_story_share_conflict'],
        test: (context) => !!context.querySelector('.fa-container .wsw__embed--jumbo,.fa-container .wsw__embed--fullwidth')
    },
    {
        dep: ['inline_note'],
        test: (context) => !!context.querySelector('.inline-note')
    }
]);

// modules which need full page load
moduleManager.addDependencies([
    {
        dep: ['facebook_video_snippet', 'sticky_player_facebook'],
        test: (context) => !!context.querySelector('[data-sp_api=\'facebook\']')
        && !isPreviewPage
    },
    {
        dep: ['scroll_to_id'],
        test: (context) => !!context.querySelector('#entry-shared')
    },
    {
        dep: ['custom_print'], // custom print
        test: (context) => !!context.querySelector('.print-dialogue')
    }

], 'pageFullLoad');

// modules which needs to be re-initialized on Quiz update
// this part should be loaded later as moduleManager.trigger('updateHtml', document.body)
moduleManager.addDependencies([
    {
        // html5 player can be dynamically loaded by AJAX POST request in form submit handler in Quiz
        dep: [
            'multimedia_player_utils', 'multimedia_player_mpd',
            'multimedia_player_analytics', 'multimedia_player_core', 'multimedia_player_ui'
        ],
        test: (context) => !!context.querySelector('.c-mmp')
    },
    {
        dep: ['simple_captcha']
    },
    {
        dep: ['popup_opener'],
        test: (context) => !!context.querySelector('.btn-popout-player')
    },
    {
        dep: ['content_sharing'], // new content sharing
        test: (context) => !!context.querySelector('.js-content-sharing')
    },
    {
        dep: ['content_sharing_player'], // old content sharing is now used only for MMP
        test: (context) => !!context.querySelector('.js-share--expandable')
    },
    {
        dep: ['swipe_slide'],
        test: (context) => !!context.querySelector('.swipe-slide')
    },
    {
        dep: ['validation', 'quiz'],
        test: (context) => !!context.querySelector('.quiz')
    },
    {
        dep: ['smooth_scroll'],
        test: (context) => !!context.querySelector('a[href^="#"]')
    },
    {
        dep: ['image_expander'],
        test: (context) => !!context.querySelector('.c-lightbox')
    },
    {
        dep: ['slider_gallery'],
        test: (context) => !!context.querySelector('.js-img-compare')
    },
    {
        dep: ['load_more'],
        test: (context) => !!context.querySelector('.link-showMore')
        || !!context.querySelector('.tab-loadContent')
        || !!context.querySelector('.link-ajax')
        || !!context.querySelector('.lazy-scroll-load')
    },
    {
        dep: ['graphic_content'],
        test: (context) => !!context.querySelector('.content-advisory')
    },
    {
        dep: ['switcher'],
        test: (context) => !!context.querySelector('[data-switcher-trigger="true"]')
    },
    {
        dep: ['accordeon'],
        test: (context) => !!context.querySelector('.accordeon__item')
    },
    {
        dep: ['news_layout'],
        test: (context) => !!context.querySelector('#newsItems')
    },
    {
        dep: ['sticky_btn_panel'],
        test: (context) => (!!context.querySelector('.sticky-btn')
        || (!!context.querySelector('.sticky-panel') && (typeof CSS === 'undefined' || !CSS.supports('position', 'sticky'))))
        && !isPreviewPage
    },
    {
        dep: ['share_link'],
        test: (context) => !!context.querySelector('.ctc')
    },
    {
        dep: ['validation', 'comments'],
        test: (context) => !!context.querySelector('.comments--pangea')
        && !context.querySelector('.news__comments')
    },
    {
        dep: ['content_floated'],
        test: (context) => !!context.querySelector('.content-floated')
    },
    {
        dep: ['combobox_helper'],
        test: (context) => !!context.querySelector('.dropdown')
    },
    {
        dep: ['slider_nav_tabs'],
        test: (context) => !!context.querySelector('.nav-tabs')
    },
    {
        dep: ['video_enhancer'],
        test: (context) => !!context.querySelector('.video')
    },
    {
        dep: ['sharing_open'],
        test: (context) => !!context.querySelector('.share__item')
    },
    {
        dep: ['flexible_iframe'],
        test: (context) => !!context.querySelector('.flexible-iframe')
    },
    {
        dep: ['comments_load_more'],
        test: (context) => !!context.querySelector('.btn--load-more-comments')
    },
    {
        dep: ['comment_pangea'],
        test: (context) => !!context.querySelector('.comment--pangea')
    },
    {
        dep: ['validation', 'subscribe'],
        test: (context) => !!context.querySelector('.subscribe')
    },
    {
        dep: ['validation', 'poll'],
        test: (context) => !!context.querySelector('.poll')
    },
    {
        dep: ['async_loaded_player'],
        test: (context) => !!context.querySelector('.aslp')
    },
    {
        dep: ['podcast_wg'],
        test: (context) => !!context.querySelector('.podcast-wg')
    },
    {
        dep: ['podcast_sub'],
        test: (context) => !!context.querySelector('.podcast-sub')
    },
    {
        dep: ['non_form_sys_msg'],
        test: (context) => !!context.querySelector('.calendar-component .sys-msg')
    },
    {
        dep: ['sticky_player_pangea_video'],
        test: (context) => !!context.querySelector('[data-sp_api=\'pangea-video\']')
        && RFE.stickyPlayers === undefined
        && !isPreviewPage
    },
    {
        dep: ['sticky_player_youtube'],
        test: (context) => !!context.querySelector('[data-sp_api=\'youtube\']')
        && RFE.stickyPlayers === undefined
        && !isPreviewPage
    },
    {
        dep: ['sticky_player_history_handler'],
        test: () => !!window.history
        && RFE.stickyPlayers === undefined
        && !isPreviewPage
    },
    {
        dep: ['sticky_player'],
        test: (context) => !!context.querySelector('[data-sp_api]')
        && RFE.stickyPlayers === undefined
        && !isPreviewPage
    },
    {
        dep: ['slider_fred'],
        test: (context) => !!context.querySelector('.fredContent__controls')
    },
    {
        dep: ['live_blog_page_notification'],
        test: (context) => !!context.querySelector('.update-liveblog')
        && !isPreviewPage
    },
    {
        dep: ['feature_story_share_conflict'],
        test: (context) => !!context.querySelector('.fa-container .wsw__embed--jumbo,.fa-container .wsw__embed--fullwidth')
    },
    {
        dep: ['inline_note'],
        test: (context) => !!context.querySelector('.inline-note')
    }
], 'updateHtml');

// modules that need to be re-initialized when lightbox opens and has intro
// this phase is triggered after lightbox intro contents are finished and just for that intro
moduleManager.addDependencies([
    {
        dep: ['content_sharing'], // new content sharing
        test: (context) => !!context.querySelector('.js-content-sharing')
    },
    {
        dep: ['content_sharing_player'], // old content sharing is now used only for MMP
        test: (context) => !!context.querySelector('.js-share--expandable')
    },
    {
        dep: ['share_link'],
        test: (context) => !!context.querySelector('.ctc')
    },
    {
        dep: ['graphic_content'],
        test: (context) => !!context.querySelector('.content-advisory')
    },
    {
        dep: ['inline_note'],
        test: (context) => !!context.querySelector('.inline-note')
    }
], 'lightbox');

// this phase is triggered when showing comments on news layout
moduleManager.addDependencies([
    {
        dep: ['validation', 'comments'],
        test: (context) => !!context.querySelector('.comments-parent')
    },
    {
        dep: ['sticky_btn_panel'],
        test: (context) => !!context.querySelector('.sticky-btn') && !isPreviewPage
    }
], 'newslayoutComments');

const contentLoaded = async () => {
    // init image enhancer
    imenh.initGlobal();
    // init optimized events
    optimEvs.initGlobal();
    // set the default context for the loader
    window.defaultLoaderContext = document.documentElement;
    // initialize modules
    await moduleManager.init(window.defaultLoaderContext);
};
if (document.readyState === 'loading') {
    // standard modules supporting DOMContentLoaded
    window.addEventListener('DOMContentLoaded', async () => {
        contentLoaded();
    });
}
else {
    // somehow DOMContentLoaded already happened and we didn't listen
    contentLoaded();
}

// modules which need full page load
window.addEventListener('load', async () => {
    // set the default context for the loader
    window.defaultLoaderContext = document.documentElement;
    moduleManager.trigger('pageFullLoad', window.defaultLoaderContext);
});

window.addEventListener('pageshow', async (event) => {
    if (event.persisted) {
        // page is reloaded from Back/Forward Cache (bfcache) (by using system navigation)
        window.defaultLoaderContext = document.documentElement;
        moduleManager.trigger('pageFullLoad', window.defaultLoaderContext);
    }
});

window.addEventListener('beforeunload', () => {
    // deinit image enhancer
    imenh.deinitGlobal();
    // deinit optimized events;
    optimEvs.deinitGlobal();
})

window.moduleManager = moduleManager;

// analytics
window.getAnalyticsPageData = getAnalyticsPageData;
window.trackAnalyticsEvent = trackAnalyticsEvent;
window.trackAnalyticsView = trackAnalyticsView;
window.FireAnalyticsTagEventOnDownload = FireAnalyticsTagEventOnDownload;
window.FireAnalyticsTagEventOnSearch = FireAnalyticsTagEventOnSearch;
window.FireAnalyticsTagEventOnSearchResultItemClick = FireAnalyticsTagEventOnSearchResultItemClick;
window.FireAnalyticsTagEventQuiz = FireAnalyticsTagEventQuiz;
window.FireTealiumEvent = FireTealiumEvent;
window.FireTealiumEventOnDownload = FireTealiumEventOnDownload;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./source/js/modules/app_code.ts